import { NotFoundPage } from '~/components/v2/ErrorPage'

export default function Custom404() {
  return <NotFoundPage />
}

Custom404.trackPageViews = false
